<micro-select-combo #sel
              placeholder="Airtime Carrier Type"
              [mode]="mode"
              [(id)]="airtimeCarrierTypeId"
              (idChange)="change($event)"
              [options]="options"
              [required]="required"
              [disabled]="disabled"
>
</micro-select-combo>
